import Vue from 'vue'

const mutations = {
  robots: (state, robots) => {
    return Vue.set(
      state,
      'robots',
      robots
    )
  },
  currentRobot: (state, robot) => {
    return Vue.set(
      state,
      'currentRobot',
      robot
    )
  },
  eventRobotCount: (state, count) => Vue.set(state, 'eventRobotCount', count),
  robotsEventId: (state, id) => Vue.set(state, 'robotsEventId', id)
}

export default mutations
